import { Component, OnInit } from '@angular/core';

import { CheckoutFooterCms } from '~/cms/interfaces/checkout-footer.cms.interface';
import { CmsService } from '~/cms/services/cms/cms.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  public checkoutFooter: CheckoutFooterCms;

  constructor(private readonly cmsService: CmsService) {}

  public ngOnInit(): void {
    this.cmsService.getCheckoutFooter().subscribe((checkoutFooter) => {
      this.checkoutFooter = checkoutFooter;
    });
  }
}
